import {
  HttpHeaders,
  HttpClient,
  HttpBackend,
  HttpParams,
} from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import {
  TechLibPortalConfig,
  TECH_LIB_PORTAL_CONFIG,
} from '../../../tech-lib-portal.interceptor';
import { SessionService } from '../../../services/session.service';
import { twoFAEnum } from '../../../services/api-names';
import { Utils } from '../../../utils/utils';

@Injectable({
  providedIn: 'root',
})
export class TwoFaService {
  HttpHeaders: HttpHeaders;

  constructor(
    @Inject(TECH_LIB_PORTAL_CONFIG) private config: TechLibPortalConfig,
    private httpBackend: HttpBackend,
    private session: SessionService,
    private router: Router,
    private http: HttpClient,
    private route: ActivatedRoute
  ) {}

  private updateSession() {
    this.config.sessionToken = this.session.sessionToken;
    this.config.domain = this.session.domain;
  }

 public verificationCode2FA(deviceId: string, processId:string, code:string, clientcode:string): Observable<any> {
    this.updateSession();
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.set('Tower30-Domain', this.config.domain);
    headers = headers.append('Tower30-VerifyCode', code);
    headers = headers.append('Tower30-ClientCode', clientcode);
    var url = Utils.formatString(
      this.config.baseApi +
      twoFAEnum.verify_2fa,
      [processId, deviceId]
    );
    return this.http.post<any>(url, null, {headers: headers});
  }

 public resendCode(processId:string, clientcode:string): Observable<any> {
    this.updateSession();
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.set('Tower30-Domain', this.config.domain);
    headers = headers.set('Tower30-Language', this.config.language);
    headers = headers.append('Tower30-ClientCode', clientcode);

    var url = Utils.formatString(
      this.config.baseApi +
      twoFAEnum.resendcode_2fa,
      [processId]
    );
    return this.http.post<any>(url, null, {headers: headers});
  }

  
}
